export const INITIAL_MARKETER_PASSWORD = 'zigzag1234!';
